export default function getIsRedesign(state) {
  return state.redesign;
}
